module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_maedori_01-9a65bd59aae0a305ff02fced1e44a1ff.webp";